import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import { makeTag } from '../../../svg/utils';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import {
  createSquareNodeTypeIcon,
  getRoundedRectanglePath,
  wrapNodeIconInSvgTag,
} from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

const HOST_FRAME_SIZE = 1.4;

const hostDefaultOptions = {
  ...nodeIconDefaultOptions,
  style: { background: 'black' },
} satisfies Partial<NodeIconOptions>;

function createHostIcon(options: NodeIconOptions = {}): string {
  const opts = { ...hostDefaultOptions, ...options };

  const drawHorizontalBar = (y: number) =>
    makeTag('rect', {
      x: 13.2,
      y,
      width: 13.6,
      height: 3.6,
      fill: ICON_DEFAULT_FOREGROUND_COLOR,
    });

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    ${makeTag('path', {
      d: getRoundedRectanglePath(9.6, 4, 20.8, 32.8, HOST_FRAME_SIZE),
      fill: 'none',
      stroke: ICON_DEFAULT_FOREGROUND_COLOR,
      'stroke-width': HOST_FRAME_SIZE,
    })}
    ${drawHorizontalBar(9.2)}
    ${drawHorizontalBar(16.4)}
    ${makeTag('circle', {
      cx: 20,
      cy: 27.2,
      fill: ICON_DEFAULT_FOREGROUND_COLOR,
      r: 2,
    })}
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const hostIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createHostIcon,
);
